import { Button } from "@fluentui/react-components";
import { makeStyles } from "@fluentui/react-components";
import { Dismiss24Filled, Navigation24Filled } from "@fluentui/react-icons";
import { useEffect, useState } from "react";
import { OverlayDrawer, DrawerHeader, DrawerHeaderTitle, DrawerBody } from "@fluentui/react-drawer";  // Import the OverlayDrawer components
import DesktopMenu from "./desktop/DesktopMenu";
import MobileMenu from "./mobile/MobileMenu";
import Logo from "./Logo";
import Status from "../../enums/Status";
import INavigationArea from "../../models/navigation/INavigationArea";
import navigationService from "../../services/NavigationService";

const useStyles = makeStyles({
  	navContainer: {
		display: "flex",
		justifyContent: "space-between",
		alignItems: "center",
		padding: "0 2rem",
		height: "60px",
		maxWidth: "1500px",
		margin: "0 auto",
		overflow: "visible",
	},
	burgerMenu: {
		display: "none",
		
		"@media (max-width: 768px)": {
			display: "flex",
		}
	}
});

const BtnDismiss = (props: { onDismiss: () => void }) => (
	<Button
		appearance="subtle"
		aria-label="Close"
		icon={<Dismiss24Filled />}
		onClick={props.onDismiss}
		/>
);

export default function Navigation() {
	const styles = useStyles();

	const [isOpen, setIsOpen] = useState(false);
	const [nav, setNav] = useState<INavigationArea[]>([]);
	const [status, setStatus] = useState<Status>(Status.LOADING);

	useEffect(() => {
		fetchNav(setNav, setStatus);
	}, []);

	const handleMobileMenuOpenChange = (isOpen: boolean) => setIsOpen(isOpen);
	const handleMobileNavigate = () => setIsOpen(false);
	const handleMobileDismiss = () => setIsOpen(false);

	return (
		<div className={styles.navContainer}>
			{/* Logo Section */}
			<Logo />

			{/* Menu Section */}
			<DesktopMenu status={status} areas={nav} />

			{/* Burger Menu for Mobile */}
			<Button
				className={styles.burgerMenu}
				appearance="subtle"
				onClick={() => setIsOpen(!isOpen)}  // Toggle drawer on click
				icon={isOpen ? null : <Navigation24Filled />}
				/>

			{/* Drawer for Mobile */}
			<OverlayDrawer
				as="aside"
				open={isOpen}
				onOpenChange={(_, data) => handleMobileMenuOpenChange(data.open)}
				position="end"
				>
					<DrawerHeader>
						<DrawerHeaderTitle action={<BtnDismiss onDismiss={handleMobileDismiss} />} />
					</DrawerHeader>
					<DrawerBody>
						<MobileMenu
							areas={nav}
							status={status}
							onNavigate={handleMobileNavigate}
							/>
					</DrawerBody>
			</OverlayDrawer>
		</div>
  	);
}

async function fetchNav(
	setNavigation: (nav: INavigationArea[]) => void,
	setStatus: (status: Status) => void
) {
	try {
		const nav = await navigationService.getNavigation();

		setNavigation(nav);
		setStatus(Status.LOAD_SUCCESS);
	} catch {
		setStatus(Status.LOAD_ERROR);
	}
}